module.exports = __webpack_public_path__ + "static/media/platform_chrome.168a057e.png";